import { render, staticRenderFns } from "./sale-create-header.vue?vue&type=template&id=7b2b1868&"
import script from "./sale-create-header.ts?vue&type=script&lang=ts&"
export * from "./sale-create-header.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports